<template>
  <div class="list-con" :class="{ 'large-font-mode': pageData.largeFontMode }">
    <!--        名单列表 start        -->
    <div class="list-container flex flex-col align-center">
      <div
        v-for="item in pageData.diagRecords"
        :key="item.id"
        class="list-item w-full flex flex-row justify-between"
        :class="{ 'active': item.code === pageData.activeDiagRecord.diagRecord?.code }"
        @click="handleClickDiagRecord(item)"
      >
        <div class="name-con flex flex-row align-center">
          <img
            v-if="item.sexSign==='2'"
            class="profile"
            alt="头像"
            src="../../../../../../assets/treatment/profileFemale.png"
          >
          <img
            v-else
            class="profile"
            alt="头像"
            src="../../../../../../assets/treatment/profileMale.png"
          >
          <div class="name mr-5">{{ item.name }}</div>
        </div>
        <div class="info flex flex-row align-center">
          <div class="gender flex flex-row align-center">{{ item.sexSign === "1" ? "男" : "女" }}</div>
        </div>
      </div>
    </div>
    <!--        名单列表 end        -->
  </div>
</template>
<script>

import { findPage, getById, postData } from '@/api/ik/data/dataApi'

export default {
  filters: {
    /**
     * 就诊记录状态
     * @param stateSign
     * @returns {string}
     * @constructor
     */
    STATE_SIGN(stateSign) {
      switch (stateSign) {
        case "1":
          return "待就诊"
        case "2":
          return "待配药"
        case "3":
          return "待结算"
        case "4":
          return "待取药"
        case "5":
          return "已完成"
        case "6":
          return "已关闭"
        default:
          return ""
      }
    }
  },
  inject: ["pageData"],
  mounted() {
    this.findDiagRecord()
  },
  methods: {
    /**
     * 查询就诊记录
     */
    findDiagRecord() {
      const pd = {
        searchData: {
          storeCode: this.pageData.storeCode
        }
      }
      postData("clinic/treatment/treatment/diagrecord/find/findAll", JSON.stringify(pd))
        .then(res => {
          this.pageData.diagRecords = res.data
          const uniqueByPatientId = (data) => {
            // 空值校验，避免传入非数组或空数组时报错
            if (!Array.isArray(data) || data.length === 0) return []

            const patientMap = new Map()
            // 遍历数组，保留每个patientId的第一条记录（若要保留最后一条，去掉if判断即可）
            data.forEach(item => {
              // 确保item和patientId存在，避免无效数据
              if (item && item.patientId && !patientMap.has(item.patientId)) {
                patientMap.set(item.patientId, item)
              }
            })

            // 将Map的值转换为数组返回
            return Array.from(patientMap.values())
          }
          this.pageData.diagRecords = uniqueByPatientId(res.data)
          let index = false
          this.pageData.diagRecords.forEach(element => {
            if (element.code === this.pageData.activeDiagRecord.diagRecord.code) {
              index = true
            }
          })
          if (!index) {
            this.pageData.activePatientInfo = {}
            this.pageData.dispatchVisible = false
          }
        })
    },
    /**
     * 点击就诊记录
     * @param diagRecord 就诊记录
     */
    handleClickDiagRecord(diagRecord) {
      // 核心修改：赋值选中的就诊记录，用于选中状态判断
      this.pageData.activeDiagRecord.diagRecord = diagRecord
      this.getPatientInfo(diagRecord.patientId)
      this.findHisDiagRecord(diagRecord.patientId)
      // this.getActivePreDiagRecord(diagRecord.code)
    },
    /**
     * 获取病人信息
     * @param patientId
     */
    getPatientInfo(patientId) {
      const bgPath = "clinic/treatment/patient/patient"
      getById(bgPath, patientId)
        .then(res => {
          this.pageData.activePatientInfo = res.data.head
        })
    },
    /**
     * 查询历史诊疗记录
     * @param patientId
     */
    findHisDiagRecord(patientId) {
      const bgPath = "clinic/treatment/treatment/diagrecord"
      const pd = {
        storeCode: this.pageData.storeCode,
        stateSign: "5",
        patientId
      }
      findPage(bgPath, pd, 3, 1)
        .then(res => {
          this.pageData.hisTreatmentRecords = res.data.list
          console.log(this.pageData.hisTreatmentRecords)
        })
    },
    /**
     * 获取进行中的预诊记录
     * @param code
     */
    getActivePreDiagRecord(code) {
      const url = "clinic/treatment/treatment/diagrecord/find/finddiagrecord"
      const pd = {
        code
      }
      postData(url, pd)
        .then(res => {
          this.pageData.resetActiveDiagRecord()
          this.pageData.activeDiagRecord = {
            ...this.pageData.activeDiagRecord,
            ...res.data
          }
          if (res.data.treatmentRecord.code) {
            postData('pharmacy/storage/agentpre/agentprescription/find/gettreatmentrecord', { code: res.data.treatmentRecord.code }).then(res => {
              console.log(res)
              this.pageData.activeDiagRecord.dsPrescription = res.data.agentPrescription || { // 代煎处方
                pharmacyCode: "",
                pharmacyName: "",
                doseNum: 0,
                dayDoseNum: 0
              }
              this.pageData.activeDiagRecord.dsPrescriptionItemList = res.data.agentPrescriptionItemList || []
              this.pageData.activeDiagRecord.djPrescription = res.data.chagentPrescription || { // 代煎处方
                pharmacyCode: "",
                pharmacyName: "",
                serveFeeSign: "00",
                doseNum: 0,
                dayDoseNum: 0,
                dayFreq: 0
              }
              this.pageData.activeDiagRecord.djPrescriptionItemList = res.data.chagentPrescriptionItemList || []
            })
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
  /* 大字模式样式 */
.large-font-mode {
  font-size: 1.2em;

  .label-con {
    .label {
      font-size: 18px;
      line-height: 28px;
    }
  }

  .el-form-item {
    margin-bottom: 10px;

    ::v-deep .el-form-item__label {
      font-size: 15px;
      line-height: 32px;
    }

    ::v-deep .el-input__inner,
    ::v-deep .el-input-number .el-input__inner {
      font-size: 15px;
      height: 36px;
      line-height: 36px;
    }

    ::v-deep .el-input-number {
      line-height: 34px;
    }
  }

  .el-col {
    margin-bottom: 8px;
  }
}
// 列表容器
.list-con {
  .list-search-input {
    width: 176px;
    height: 24px;
    background: #FFFFFF;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #E5E6EB;
    margin-bottom: 20px;
  }

  .list-container {
    height: 584px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 0;
    }

    .list-item {
      &:hover {
        cursor: pointer;
        background-color: #F7F8FA; // 悬浮浅灰背景（可选）
      }

      // 核心：选中状态样式（字体加粗+蓝色）
      &.active {
        .name {
          font-weight: bold !important;
          color: #1890FF !important; // 蓝色（可替换为你需要的色值）
        }
        .gender {
          font-weight: bold !important;
          color: #1890FF !important; // 性别文字也同步加粗+蓝色（可选）
        }
      }

      padding: 14px 12px;
      transition: all 0.2s ease; // 过渡动画，样式切换更流畅

      .name-con {
        .profile {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }

        .name {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: bold;
          font-size: 14px;
          color: #1D2129;
          line-height: 14px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          transition: color 0.2s ease; // 颜色过渡
        }
      }

      .info {
        .gender {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: normal;
          font-size: 14px;
          color: #86909C;
          line-height: 14px;
          text-align: right;
          font-style: normal;
          text-transform: none;
          transition: color 0.2s ease; // 颜色过渡
        }
      }

    }
  }
}

@media (min-height: 920px) {
  // 列表容器
  .list-con {
    .list-search-input {
      width: 176px;
      height: 24px;
      background: #FFFFFF;
      border-radius: 2px 2px 2px 2px;
      border: 1px solid #E5E6EB;
      margin-bottom: 20px;
    }

    .list-container {
      height: 72.5vh;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        width: 0;
      }

      .list-item {
        &:hover {
          cursor: pointer;
          background-color: #F7F8FA;
        }

        // 大屏下同步选中样式
        &.active {
          .name {
            font-weight: bold !important;
            color: #1890FF !important;
          }
          .gender {
            font-weight: bold !important;
            color: #1890FF !important;
          }
        }

        padding: 14px 12px;
        transition: all 0.2s ease;

        .name-con {
          .profile {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }

          .name {
            font-family: PingFang SC, PingFang SC, serif;
            font-weight: bold;
            font-size: 14px;
            color: #1D2129;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }

        .info {
          .gender {
            font-family: PingFang SC, PingFang SC, serif;
            font-weight: normal;
            font-size: 14px;
            color: #86909C;
            line-height: 14px;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }
        }

      }
    }
  }
}
</style>
